import React from 'react';
import { Field } from 'redux-form';
import Loader from '../../../../common/components/Loader/Loader';
import TextArea from '../../../content/components/TextArea/TextArea';
import { Col, Row } from 'react-bootstrap';
import { FormGroupInput } from '../../../../common/form/components/components';
import startCase from '../../../../helpers/socratesLodash/startCase';
import {
  WhiteLabelContentContainer
} from '../WLContentContainer/WhiteLabelContentContainer';

const ComponentMap = {
  textarea: TextArea,
  text: FormGroupInput,
};

const PrivacyPageSections = ({ template, input }) => {
  return (
    <>
      {Object.keys(template.data.attributes.sections).map((templateSectionKey) => {
        //loop through top level sections
        const fieldType = template.data.attributes.sections[templateSectionKey].fieldtype;
        return (
          <div key={templateSectionKey}>
            <Row>
              <Col sm={12}>
                <Field
                  key={templateSectionKey}
                  name={`${input.name}.${templateSectionKey}`}
                  type={templateSectionKey}
                  label={startCase(templateSectionKey)}
                  labelSize={2}
                  colSize={12}
                  component={ComponentMap[fieldType]}
                />
              </Col>
            </Row>
          </div>
        );
      })}
    </>
  );
};

const PrivacyPage = ({ template }) => {
  return (
    <WhiteLabelContentContainer title={'Privacy page content'}>
      {template ? (
        <Field
          name={'meta.privacy.content.attributes.sections'}
          template={template}
          component={PrivacyPageSections}
        />
      ) : (
        <Loader/>
      )}
    </WhiteLabelContentContainer>
  );

};
export default PrivacyPage;
